module.exports = __webpack_public_path__ + "assets/neutral.58674629.svg";